import { reduxForm, change, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { createInventoryRelocation, editInventoryRelocation, fetchInventoryRelocationDetail } from '../../actions/inventoryRelocations_actions';
import { fetchInventories } from '../../actions/inventoryConverts_actions';
import { fetchWarehouses } from '../../actions/warehouses_actions';
import { fetchWarehouseDetail } from '../../actions/warehouses_actions';
import InventoryRelocationForm from '../../components/Inventories/inventoryRelocationForm';
import { fetchZoneDetail } from '../../actions/zones_actions';

const validate = values => {
  const errors = {}
  if (!values.Quantity) {
      errors.Quantity = 'Required'
  }
  return errors
}

let inventoryRelocationForm = reduxForm({
    form: 'inventoryRelocationForm',
    validate
})(InventoryRelocationForm);

const selector = formValueSelector('inventoryRelocationForm');

function mapStateToProps(state) {
    const toZoneValue = selector(state, 'ToZone');
    const toBinValue = selector(state, 'ToBin');
    const quantityValue = selector(state, 'Quantity');
    const postingDate = selector(state, 'PostingDate');
    const note = selector(state, 'Note');
    const Default_Warehouse_id = selector(state, 'Default_Warehouse_id');
    const Default_WarehouseZone_id = selector(state, 'Default_WarehouseZone_id');
    return {
        Default_Warehouse_id,
        Default_WarehouseZone_id,
        quantityValue,
        toZoneValue,
        toBinValue,
        postingDate,
        note,

        currentZoneDetail : state.zones.currentZoneDetail,
        bins: state.zones.bins,
        detailIsLoading: state.zones.detailIsLoading,
        detailError: state.zones.detailError,

        currentInventoryRelocation: state.inventoryRelocations.currentInventoryRelocation,
        currentInventoryRelocationDetail: state.inventoryRelocations.currentInventoryRelocationDetail,
        detailIsLoading: state.inventoryRelocations.detailIsLoading,
        detailError: state.inventoryRelocations.detailError,
        initialValues: state.inventoryRelocations.currentInventoryRelocationDetail,
        isCreating: state.inventoryRelocations.isCreating,
        createError: state.inventoryRelocations.createError,
        created: state.inventoryRelocations.created,
        isEditing: state.inventoryRelocations.isEditing,
        editError: state.inventoryRelocations.editError,
        edited: state.inventoryRelocations.edited,

        inventories: state.inventoryConverts.inventories,
        vendorIsLoading: state.inventories.isLoading,
        vendorError: state.inventories.error,
        warehouses: state.warehouses.all,
        currentWarehouseDetail: state.warehouses.currentWarehouseDetail,
        userPermissions: state.auth.userPermissions
    }
}

export default connect(mapStateToProps, { fetchWarehouses, fetchWarehouseDetail, createInventoryRelocation, editInventoryRelocation, fetchInventoryRelocationDetail, fetchInventories, fetchZoneDetail })(inventoryRelocationForm)



// WEBPACK FOOTER //
// ./master/jsx/containers/Inventories/inventoryRelocationForm.jsx